/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CharacteristicColorFromJSON, CharacteristicColorToJSON, } from './CharacteristicColor.js';
/**
 * Check if a given object implements the ListPersonalCharacteristicsPersonalCharacteristicDto interface.
 */
export function instanceOfListPersonalCharacteristicsPersonalCharacteristicDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('color' in value) || value['color'] === undefined)
        return false;
    return true;
}
export function ListPersonalCharacteristicsPersonalCharacteristicDtoFromJSON(json) {
    return ListPersonalCharacteristicsPersonalCharacteristicDtoFromJSONTyped(json, false);
}
export function ListPersonalCharacteristicsPersonalCharacteristicDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'color': CharacteristicColorFromJSON(json['color']),
    };
}
export function ListPersonalCharacteristicsPersonalCharacteristicDtoToJSON(json) {
    return ListPersonalCharacteristicsPersonalCharacteristicDtoToJSONTyped(json, false);
}
export function ListPersonalCharacteristicsPersonalCharacteristicDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'color': CharacteristicColorToJSON(value['color']),
    };
}
